<template>
  <div class="crop-timeline">
    <div
      ref="sliderDom"
      v-dragWhole
      class="time-slider"
    >
      <div class="time-slider-rail"></div>
      <div
        class="time-slider-track"
        :style="{
          width: ((info.val - info.min) / (info.max - info.min)) * 100 + '%'
        }"
      ></div>
      <div
        class="time-slider-mask"
        data-action="click"
      ></div>
      <div
        data-action="handle"
        class="time-slider-handle"
        :style="{ left: ((info.val - info.min) / (info.max - info.min)) * 100 + '%' }"
      ></div>
    </div>
  </div>
</template>
<script>
export default {
  name: 'CropTimeline',
  props: {
    info: {
      type: Object,
      required: true,
      limitLeft: 0,
      default: function() {
        return { step: 0.1, min: 0, max: 10, val: 0 };
      }
    }
  },
  data() {
    return {
      width: 100,
      action: '',
      mpos: null
    };
  },
  methods: {
    dragDown(dis, action) {
      if (!action) return;

      this.width = this.$refs.sliderDom.clientWidth;

      if (action === 'handle') {
        this.action = action;
        this.mpos = {
          val: this.info.val,
          x: dis.x
        };
        this.$emit('changeData', { val: this.info.val, action: action, type: 'start' });
      } else if (action === 'click') {
        let { left: left } = this.$refs.sliderDom.getBoundingClientRect();
        let pre = Math.round((((dis.x - left) / this.width) * (this.info.max - this.info.min)) / this.info.step) / (1 / this.info.step);
        let val = pre > this.info.max ? this.info.max : pre < this.info.min ? this.info.min : pre;
        this.$emit('changeData', { val: val, action: action, type: 'change' });
      }
    },
    dragMove(pos) {
      if (this.action === 'handle') {
        let pre =
          Math.round((((pos.x - this.mpos.x) / this.width) * (this.info.max - this.info.min) + this.mpos.val) / this.info.step) / (1 / this.info.step);
        let val = pre > this.info.max ? this.info.max : pre < this.info.min ? this.info.min : pre;
        this.$emit('changeData', { val: val, action: this.action, type: 'change' });
      }
    },
    dragUp() {
      if (!this.action) return;
      this.$emit('changeData', { action: this.action, type: 'end' });
      this.action = '';
      this.mpos = null;
    }
  }
};
</script>
<style lang="scss" scoped>
.crop-timeline {
  width: 100%;
  height: 30px;
}
.time-slider {
  position: relative;
  height: 30px;
  width: 100%;
  -ms-touch-action: none;
  touch-action: none;
  -webkit-box-sizing: border-box;
  box-sizing: border-box;
  -webkit-tap-highlight-color: rgba(0, 0, 0, 0);
  * {
    -webkit-box-sizing: border-box;
    box-sizing: border-box;
    -webkit-tap-highlight-color: rgba(0, 0, 0, 0);
  }

  .time-slider-rail {
    position: absolute;
    width: 100%;
    background-color: rgba(0, 0, 0, 0.1);
    height: 10px;
    border-radius: 5px;
  }

  .time-slider-track {
    position: absolute;
    background-color: #2f58fe;
    height: 10px;
    left: 0%;
    width: 69.1515%;
    border-radius: 5px;
  }

  .time-slider-mask {
    position: absolute;
    width: 100%;
    height: 10px;
    left: 0;
    cursor: pointer;
    opacity: 0;
  }

  .time-slider-handle {
    position: absolute;
    margin-left: -15px;
    margin-top: -10px;
    left: 69.1515%;
    width: 30px;
    height: 30px;
    background-color: #ffffff;
    box-shadow: 0px 5px 30px 0px rgba(22, 64, 234, 0.16);
    border-radius: 50%;
    cursor: -webkit-grab;
    cursor: grab;
    -ms-touch-action: pan-x;
    touch-action: pan-x;
    z-index: 50;
  }
}
</style>
